import {GameStateEnums} from '../../../../../shared/GameEnums'
import {ActionsThatCanBeCancelled, PieceTypes} from '@colonist/game-base-types'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonViewWithBadge} from './UIGameActionButtonViewWithBadge'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {getCardsForPiece} from '@colonist/game-card-types'
import {UIGameActionButtonPositions} from './UIGameActionsController'
import {MechanicValidatorCityWall} from '@colonist/game-mechanic-validators'
import {ActionState, MechanicCityWallState, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export class UIGameActionButtonViewCityWall extends UIGameActionButtonViewWithBadge {
    private readonly validatorCityWall: MechanicValidatorCityWall

    constructor(uiGameManager: UIGameManager, cityWallState: MechanicCityWallState, container: PIXI.Container) {
        const texture = UIGameSpriteHandler.getCityWallForPlayer(uiGameManager.gameController.myColor)
        const validatorCityWall = new MechanicValidatorCityWall(uiGameManager.gameController.getPlayerValidators(), uiGameManager.gameController.mapValidator, cityWallState)
        const cityWallAmount = validatorCityWall.getCityWallPlayerState(uiGameManager.gameController.myColor).bankCityWallAmount
        super(uiGameManager, UIGameActionButtonPositions.CityWall, container, cityWallAmount)
        this.addCenteredIcon(texture)
        this.validatorCityWall = validatorCityWall

        this.setUpdateAction()
        this.stateUpdated()
        const cardsToBuildCityWall = getCardsForPiece(PieceTypes.CityWall)
        this.setHoverAction(cardsToBuildCityWall)
    }

    private setUpdateAction() {
        this.updateAction(() => {
            this.clickedCityWallButton()
        })
    }

    protected playerStateUpdated() {
        const cityWallPlayerState = this.validatorCityWall.getCityWallPlayerState(this.uiGameManager.gameController.myColor)
        this.updateBadgeCount(cityWallPlayerState.bankCityWallAmount)
    }

    private clickedCityWallButton() {
        if(this.cancelBuild()) return
        if(!this.canPerformBuyAction(this.validatorCityWall.canPlayerPlaceCityWall(this.myPlayer.color))) return
        this.uiGameManager.socketGameSend.buildCityWall()
    }

    private cancelBuild(): boolean {
        if(!this.uiGameManager.gameController.isMyTurn) return false
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.PlaceCityWall) return false

        this.uiGameManager.eventController.sendEvent([], UIGameEventEnums.SetCornerHighlight)
        this.uiGameManager.socketGameSend.cancelAction()
        return true
    }

    protected stateUpdated() {
        this.inactivateOpacity()
        this.removeHighlight()

        if(!this.uiGameManager.gameController.isMyTurn) return
        if(!this.validatorCityWall.canPlayerPlaceCityWall(this.myPlayer.color).canTakeAction) return

        this.updateOpacityForTurnState()
        this.updateHighlightForActionState()
    }

    private updateOpacityForTurnState() {
        if(!this.allowableTurnStates()) return
        if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, this.uiGameManager.gameController.currentState.actionState)) return
        this.activateOpacity()
    }

    private allowableTurnStates(): boolean {
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.Turn) return true
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase) return true

        return false
    }

    private updateHighlightForActionState() {
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.PlaceCityWall) return
        this.activateOpacity()
        this.highlight()
    }
}
